export default {
    title: {
        text: '经营趋势'
    },
    tooltip: {
        trigger: 'axis',

    },
    legend: {
        data: ['收入', '成本', '费用', '税金', '利润']
    },
    toolbox: {
        feature: {
            saveAsImage: {}
        }
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: [
        {
            type: 'category',
            boundaryGap: false,
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
        }
    ],
    yAxis: [
        {
            type: 'value'
        }
    ],
    series: [
        {
            name: '收入',
            type: 'line',
            smooth: true,
            symbol: 'circle',     //设定为实心点
            symbolSize: 5,   //设定实心点的大小
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
            name: '成本',
            type: 'line',
            smooth: true,
            symbol: 'circle',     //设定为实心点
            symbolSize: 5,   //设定实心点的大小
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
            name: '费用',
            type: 'line',
            smooth: true,
            symbol: 'circle',     //设定为实心点
            symbolSize: 5,   //设定实心点的大小
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
            name: '税金',
            type: 'line',
            smooth: true,
            symbol: 'circle',     //设定为实心点
            symbolSize: 5,   //设定实心点的大小
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
            name: '利润',
            type: 'line',
            smooth: true,
            symbol: 'circle',     //设定为实心点
            symbolSize: 5,   //设定实心点的大小
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
    ]
};
